export let UpgradeMessage = "ZK_7cb";
export let ManageSubscriptionMessage = "x1PKFc";
export default {UpgradeMessage,ManageSubscriptionMessage};